import { company, contact } from './site';

/** Structured data limited to verified details from the company profile. */
export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'GeneralContractor',
  name: company.legalName,
  alternateName: company.shortName,
  url: contact.siteUrl,
  email: contact.email,
  telephone: '+267 395 4047',
  foundingDate: '2007-05',
  areaServed: { '@type': 'Country', name: 'Botswana' },
  address: {
    '@type': 'PostalAddress',
    postOfficeBoxNumber: '45721',
    addressLocality: 'Gaborone',
    addressCountry: 'BW',
  },
  knowsAbout: [
    'Road construction',
    'Road maintenance',
    'Civil engineering works',
    'Water and sanitation infrastructure',
    'Sewer infrastructure',
    'Stormwater drainage and culverts',
    'Building and structural works',
    'Paving',
  ],
};
